import {Component} from "vue-property-decorator";
import {authentication} from "@pazion/pazion-core/src/store";
import BaseMixin from "@pazion/pazion-core/src/mixins/base.mixin";

@Component
export default class AuthUsermixin extends BaseMixin {

    get isAdmin() {
        return authentication.isAdmin;
    }

    get isTenantUser() {
        return authentication.isTenant;
    }

    get isSystemUser() {
        return authentication.isSystem;
    }

    get getUserName(): string {
        return authentication.getProfile?.name ?? 'guest';
    }

    get getUserId(): Number {
        return authentication.getProfile?.id ?? -1;
    }

    get getUserRoles(): string[] {
        return authentication.getProfile?.roles ?? [];
    }
}